<template>
   <div class="conf-con">
                            <div class="intro-pic">
                                <img src="../../../assets/images/10.gif" alt="">
                            </div>
                            <p class="intro-tit">中国共产党第十次全国代表大会简介</p>
                            <p class="margin1">1973年8月24日至28日在北京举行。出席大会的代表1249人。当时全国有2800万名党员。周恩来作政治报告，王洪文作《关于修改党章的报告》。大会通过了政治报告和经修改的党章，选举了由195名委员和124名候补委员组成的中央委员会。随后召开的十届一中全会选举了中央政治局及其常务委员会，选举毛泽东为中央委员会主席，周恩来、王洪文、康生、叶剑英、李德生为副主席。十大继续了九大的“左”倾错误。</p>
                        </div>  
</template>

<script>
export default {

}
</script>

<style>

</style>